module.exports = {
  googleMapsApi: 'AIzaSyAL5fctNv7FMgZFEtpZ6dcTsRkDdMAhLFA'
}

